module.exports = new __parcel__URL__("stardust_prog_shine.5deef5b3.png").toString();